<template>
  <div id="edit-checkpoint">
    <b-container fluid="sm"  v-if="$route.params.userinfo.isAdmin">
      <h1>Edit Probelm {{ $route.params.id }} 's Checkpoint </h1>
      <b-button
        class="mr-sm-2"
        variant="primary"
        style="margin-bottom: 10px"
        @click="addCheckpointfield"
        >Add Checkpoint</b-button
      >

      <b-form inline style="margin-bottom: 10px">
        <div
          class="form-row"
          v-for="(checkpoint, index) in checkpoints"
          :key="index"
          style="margin-bottom: 10px"
        >
          <label class="mr-sm-3">Title</label>
          <b-form-input
            class="mr-sm-3"
            type="text"
            :id="`checkpoints_title_${index}`"
            v-model="checkpoints[index].title"
          ></b-form-input>
          <label class="mr-sm-3" for="job_name">Job Name</label>
          <b-form-input
            class="mr-sm-3"
            type="text"
            :id="`job_name_${index}`"
            v-model="checkpoints[index].job_name"
          ></b-form-input>
          <label class="mr-sm-3" for="score">Score</label>
          <b-form-input
            class="mr-sm-3"
            type="number"
            :id="`score_${index}`"
            v-model="checkpoints[index].score"
          ></b-form-input>
          <b-button
            class="mr-sm-3"
            variant="danger"
            @click="
              d_title = checkpoints[index].title;
              d_id = checkpoints[index].id;
              checkDeleteCheckpoint(index);
            "
            >Delete</b-button
          >
        </div>
      </b-form>
      <div>
        <b-button class="mr-sm-3" variant="primary" @click="submit" >Submit</b-button>
      </div>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>
            This action will delete Checkpoint "{{ d_title }} (ID:{{ d_id }})".
          </p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button class="mt-3" variant="primary" @click="hideWarning"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteCheckpoint(d_id)"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
export default {
  created() {

    if (this.$route.params.id != undefined) {
      this.getCheckpoint();
    }
  },
  beforeDestroy() {
  },
  data() {
    return {
      checkNum() {
        return !isNaN(this.project_id.value);
      },
      checkpoints: [
        {
          title: "",
          job_name: "",
          score: "",
        },
      ],
      origin_checkpoints_num: 0,
      d_title: "",
      d_id: "",
      is_admin: "",
    };
  },
  methods: {
    submit(){
      let self = this;
      this.checkpoints.forEach(function(item, i){
        if(i<self.origin_checkpoints_num){
          self.updateCheckpoint(item)
        }else{
          self.addCheckpoint(item)
        }
      });
      this.$router.push({ path: "/problem/" +  this.$route.params.id });
    },
    addCheckpoint(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/checkpoint";
      //let self = this;
      this.$http
        .post(api, data, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    updateCheckpoint(data) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/checkpoint/" + data.id;
      //let self = this;
      let editData = {
        title: data.title,
        job_name: data.job_name,
        score: data.score
      }

      this.$http
        .patch(api, editData, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    getCheckpoint() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/checkpoint";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response.data.length != 0) {
            self.checkpoints = response.data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            });
            self.origin_checkpoints_num = self.checkpoints.length;
          } else {
            self.checkpoints = [
              {
                title: "",
                job_name: "",
                score: "",
              },
            ];
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    addCheckpointfield() {
      //console.log(this.origin_checkpoints_num);
      this.checkpoints.push({
        title: "",
        job_name: "",
        score: "",
      });
    },
    checkDeleteCheckpoint(index){
      let self = this;
      if(index < this.origin_checkpoints_num){
        self.$refs["warning"].show();
      }else{
        self.checkpoints.splice(index, 1);
      }
    },
    deleteCheckpoint(id) {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/checkpoint/" + id;
      let self = this;
      this.$http
        .delete(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .finally(() => {
          self.getCheckpoint();
          self.hideWarning();
        });
    },
    hideWarning() {
      this.$refs["warning"].hide();
    },
  },
  computed: {},
};
</script>